module.exports = __webpack_public_path__ + "static/img/Akira_Torizuka.png";